export enum ADDRESS_MODAL_STATES {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}
